<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import {
	checkLogin
} from './libs/login';
import {
	HEADER,
	HTTP_REQUEST_URL
} from './config/app';
import {
	getShopConfig,
	silenceAuth,
	getSystemVersion,
	basicConfig,
	remoteRegister,
	post_robot
} from '@/api/public';
import Auth from '@/libs/wechat.js';
import Routine from './libs/routine.js';
import {
	silenceBindingSpread
} from '@/utils';
import {
	colorChange,
	getCrmebCopyRight
} from '@/api/api.js';
import {
	getLangJson,
	getLangVersion
} from '@/api/user.js';
import {
	mapGetters
} from 'vuex';
import colors from '@/mixins/color.js';
import Cache from '@/utils/cache';
import themeList from '@/utils/theme';
import {
	debug
} from 'util';

import Vue from 'vue';
export default {
	globalData: {
		isApp: false, //APP端才返回该值
		spid: 0,
		code: 0,
		isLogin: false,
		userInfo: {},
		MyMenus: [],
		globalData: false,
		isIframe: false,
		tabbarShow: true,
		windowHeight: 0,
		anliid: '', //视频案例的列表的关联商品id
		model: '', //使用说明搜索关键词型号
		ei: '', //服务页面ei码携带参数
		type: '',
		ip: '',
		locationInfo: '',

		mserviceuuid: "0000FFE0-0000-1000-8000-00805F9B34FB",
		mtxduuid: "0000FFE1-0000-1000-8000-00805F9B34FB",
		mrxduuid: "0000FFE1-0000-1000-8000-00805F9B34FB",

		muuidSel: 0,
		mautoSendInv: 10,
		msendText: "123",
		ble_device: null,
		languageCheckTimer: null,

	},
	mixins: [colors],
	computed: mapGetters(['isLogin', 'cartNum', 'locale']),
	watch: {
		isLogin: {
			deep: true, //深度监听设置为 true
			handler: function (newV, oldV) {
				if (newV) {
					// this.getCartNum()
				} else {
					this.$store.commit('indexData/setCartNum', '');
				}
			}
		},
		cartNum(newCart, b) {
			this.$store.commit('indexData/setCartNum', newCart + '');
			if (newCart > 0) {
				uni.setTabBarBadge({
					index: Number(uni.getStorageSync('FOOTER_ADDCART')) || 2,
					text: newCart + ''
				});
			} else {
				uni.hideTabBarRedDot({
					index: Number(uni.getStorageSync('FOOTER_ADDCART')) || 2
				});
			}
		},

	},


	onShow() {
		const queryData = uni.getEnterOptionsSync(); // uni-app版本 3.5.1+ 支持
		if (queryData.query.spread) {
			this.$Cache.set('spread', queryData.query.spread);
			this.globalData.spid = queryData.query.spread;
			this.globalData.pid = queryData.query.spread;
			silenceBindingSpread(this.globalData);
		}
		if (queryData.query.spid) {
			this.$Cache.set('spread', queryData.query.spid);
			this.globalData.spid = queryData.query.spid;
			this.globalData.pid = queryData.query.spid;
			silenceBindingSpread(this.globalData);
		}
		// #ifdef MP
		if (queryData.query.scene) {
			let param = this.$util.getUrlParams(decodeURIComponent(queryData.query.scene));
			if (param.pid) {
				this.$Cache.set('spread', param.pid);
				this.globalData.spid = param.pid;
				this.globalData.pid = param.pid;
			} else {
				switch (queryData.scene) {
					//扫描小程序码
					case 1047:
						this.globalData.code = queryData.query.scene;
						break;
					//长按图片识别小程序码
					case 1048:
						this.globalData.code = queryData.query.scene;
						break;
					//手机相册选取小程序码
					case 1049:
						this.globalData.code = queryData.query.scene;
						break;
					//直接进入小程序
					case 1001:
						this.globalData.spid = queryData.query.scene;
						break;
				}
			}
			silenceBindingSpread(this.globalData);
		}
		// #endif
	},
	async onLaunch(option) {
		let that = this;
		uni.hideTabBar()
		this.get_exchange_rate()
		basicConfig().then((res) => {
			//console.log(res.data.ip)
			uni.setStorageSync('BASIC_CONFIG', res.data);

		});

		// #ifdef H5
		if (option.query.hasOwnProperty('mdType') && option.query.mdType == 'iframeWindow') {
			this.globalData.isIframe = true;
		} else {
			this.globalData.isIframe = false;
		}
		if (!this.isLogin && option.query.hasOwnProperty('remote_token')) {
			this.remoteRegister(option.query.remote_token);
		}
		// #endif


		//优化后代码
		colorChange('color_change').then((res) => {
			const {
				is_diy,
				status
			} = res.data;

			uni.setStorageSync('is_diy', is_diy);
			uni.$emit('is_diy', is_diy);
			uni.setStorageSync('color_status', status);

			// 索引 = status - 1（对应themeList注释：0→status1，1→status2...）
			const index = status - 1;
			// 兜底取索引2（红色主题，对应status3）
			const viewColor = (index >= 0 && index < themeList.length) ? themeList[index] : themeList[2];

			uni.setStorageSync('viewColor', viewColor);
			uni.$emit('ok', viewColor, status);
		});




		// #ifdef APP-PLUS || H5
		uni.getSystemInfo({
			success: function (res) {
				// 首页没有title获取的整个页面的高度，里面的页面有原生标题要减掉就是视口的高度
				// 状态栏是动态的可以拿到 标题栏是固定写死的是44px
				let height = res.windowHeight - res.statusBarHeight - 44;
				// #ifdef H5 || APP-PLUS
				that.globalData.windowHeight = res.windowHeight + 'px';
				// #endif
				// // #ifdef APP-PLUS
				// that.globalData.windowHeight = height + 'px'
				// // #endif
			}
		});
		// #endif
		// #ifdef MP
		if (HTTP_REQUEST_URL == '') {
			console.error(
				"请配置根目录下的config.js文件中的 'HTTP_REQUEST_URL'\n\n请修改开发者工具中【详情】->【AppID】改为自己的Appid\n\n请前往后台【小程序】->【小程序配置】填写自己的 appId and AppSecret"
			);
			return false;
		}

		const updateManager = wx.getUpdateManager();
		const startParamObj = wx.getEnterOptionsSync();
		if (wx.canIUse('getUpdateManager') && startParamObj.scene != 1154) {
			const updateManager = wx.getUpdateManager();
			updateManager.onCheckForUpdate(function (res) {
				// 请求完新版本信息的回调
				// console.log(res.hasUpdate)
				if (res.hasUpdate) {
					updateManager.onUpdateFailed(function () {
						return that.Tips({
							title: '新版本下载失败'
						});
					});
					updateManager.onUpdateReady(function () {
						wx.showModal({
							title: '更新提示',
							content: '新版本已经下载好，是否重启当前应用？',
							success(res) {
								if (res.confirm) {
									updateManager.applyUpdate();
								}
							}
						});
					});
					updateManager.onUpdateFailed(function () {
						wx.showModal({
							title: '发现新版本',
							content: '请删除当前小程序，重启搜索打开...'
						});
					});
				}
			});
		}
		// #endif


		// 获取导航高度；
		uni.getSystemInfo({
			success: function (res) {
				that.globalData.navHeight = res.statusBarHeight * (750 / res.windowWidth) + 91;
			}
		});
		// #ifdef MP
		let menuButtonInfo = uni.getMenuButtonBoundingClientRect();
		that.globalData.navH = menuButtonInfo.top * 2 + menuButtonInfo.height / 2;
		const version = uni.getSystemInfoSync().SDKVersion;
		if (Routine.compareVersion(version, '2.21.3') >= 0) {
			that.$Cache.set('MP_VERSION_ISNEW', true);
		} else {
			that.$Cache.set('MP_VERSION_ISNEW', false);
		}
		// #endif

		// #ifdef H5
		// 添加crmeb chat 统计
		var __s = document.createElement('script');
		__s.src = `${HTTP_REQUEST_URL}/api/get_script`;
		document.head.appendChild(__s);
		// #endif


		this.getCrmebCopyRight()
		uni.removeStorageSync('model'); //每次打开 清理一次缓存 


	},
	// #ifdef H5
	onHide() {
		this.$Cache.clear('snsapiKey');
	},
	// #endif
	methods: {


		//获取汇率和服务费率
		get_exchange_rate() {
			uni.request({
				url: `${HTTP_REQUEST_URL}/api/get_exchange_rate`,
				method: 'get',
				enableHttp2: true,
				header: {
					'Content-Type': 'application/json',
				},
				data: '',
				success: (response) => {
					let data = response.data.data
					this.$store.commit('indexData/set_service_fee', data.service_fee || 0);
					this.$store.commit('indexData/set_exchange_rate', data.exchange_rate || 0);
					let Multilingual = data.Multilingual;

					let locale;
					let isCn = false;

					// #ifdef H5
					// h5判断域名
					isCn = (() => {
						try {
							const h = window?.location?.hostname;
							// 判断是否是localhost/127.0.0.1等本地测试环境，若有则直接返回false
							if (/^(localhost|127\.0\.0\.1)$/i.test(h)) {
								return false;
							}
							// 判断是否是.cn域名（排除.com.cn）、无域名（本地文件）等情况
							return !h || /(?<!\.com)\.cn$/i.test(h) || !/\./.test(h);
						} catch {
							return true;
						}
					})();
					this.$store.commit('indexData/set_isCn', isCn); //是否为cn域名

					// 有缓存优先使用缓存
					let Stlocale = uni.getStorageSync('locale') || ''
					if (Stlocale) {
						locale = Stlocale
					} else {
						if (Multilingual == 1) { // 根据系统判断默认语言
							const systemInfo = uni.getSystemInfoSync();
							let systemLanguage = systemInfo.language || systemInfo.lang || '';
							systemLanguage = systemLanguage.replace('_', '-').toLowerCase();
							locale = systemLanguage.startsWith('zh') ? 'zh-CN' : 'en-US';
						} else { // 根据域名判断默认语言
							locale = isCn ? 'zh-CN' : 'en-US';
						}
					}
					// #endif

					// #ifdef MP
					this.$store.commit('indexData/set_isCn', true)
					locale = 'zh-CN'; // 小程序和APP中默认中文
					// #endif

					// 设置语言
					this.SetLanguage(locale)

					// 判断是否在框架内
					if (typeof window !== 'undefined' && window.self !== window.top) {
						this.$store.commit('indexData/set_isIframe', true)
						this.startLanguageCheck()
					} else {
						this.$store.commit('indexData/set_isIframe', false)
					}

				},
			});
		},




		//设置默认语言
		SetLanguage(locale) {
			// #ifdef MP
			let appBaseInfo = wx.getAppBaseInfo() //获取设备信息
			let env = appBaseInfo.host.env.toLowerCase()
			this.globalData.isApp = env === 'wechat' ? false : true; //判断是否在APP环境中
			// #endif

			uni.setStorageSync('locale', locale);
			this.$store.commit('indexData/set_locale', locale);

			getLangJson().then(res => {
				this.$i18n.setLocaleMessage(locale, res.data[locale]);
				this.$nextTick(() => {
					this.$i18n.locale = locale;
					uni.setStorageSync('localeJson', res.data);

					// 更新当前页面标题
					this.updateCurrentPageTitle();
				});
			}).catch(err => {
				uni.showToast({
					title: this.$t('切换失败'),
					icon: 'none'
				});
			});
		},

		// 更新当前页面标题
		updateCurrentPageTitle() {
			// 获取当前页面栈
			const pages = getCurrentPages();
			if (pages.length === 0) return;

			// 获取当前页面
			const currentPage = pages[pages.length - 1];
			const route = currentPage.route;

			// 导入页面标题映射
			import('@/utils/pageTitleMapping.js').then((module) => {
				const pageTitleMapping = module.default || module;

				// 根据路由获取对应的标题键
				const titleKey = pageTitleMapping[route];

				if (titleKey) {
					// 检查是否为动态标题页面
					if (titleKey === '__DYNAMIC_TITLE__') {
						if (currentPage && currentPage.$vm) {
							let dynamicTitle = null;

							// 检查商品详情页
							if (route === 'pages/goods_details/index') {
								// 检查是否有商品信息
								if (currentPage.$vm.productInfo) {
									if (currentPage.$vm.locale === 'en-US' && currentPage.$vm.productInfo.store_name_en) {
										dynamicTitle = currentPage.$vm.productInfo.store_name_en;
									} else if (currentPage.$vm.productInfo.store_name) {
										dynamicTitle = currentPage.$vm.productInfo.store_name;
									}
								}
								// 兼容使用storeInfo的情况
								else if (currentPage.$vm.storeInfo) {
									if (currentPage.$vm.locale === 'en-US' && currentPage.$vm.storeInfo.store_name_en) {
										dynamicTitle = currentPage.$vm.storeInfo.store_name_en;
									} else if (currentPage.$vm.storeInfo.store_name) {
										dynamicTitle = currentPage.$vm.storeInfo.store_name;
									}
								}
							}
							// 检查文章详情页
							else if (route === 'pages/extension/news_details/index') {
								// 检查是否有文章信息
								if (currentPage.$vm.articleInfo) {
									if (currentPage.$vm.locale === 'en-US' && currentPage.$vm.articleInfo.title_en) {
										dynamicTitle = currentPage.$vm.articleInfo.title_en;
									} else if (currentPage.$vm.articleInfo.title) {
										dynamicTitle = currentPage.$vm.articleInfo.title;
									}
								}
							}

							if (dynamicTitle) {
								uni.setNavigationBarTitle({
									title: dynamicTitle
								});
							} else {
								// 如果动态标题不存在，使用默认的国际化标题
								const defaultTitle = this.$t('加载中...');
								uni.setNavigationBarTitle({
									title: defaultTitle
								});
							}
						} else {
							// 如果无法获取页面实例，使用默认的国际化标题
							const defaultTitle = this.$t(titleKey);
							uni.setNavigationBarTitle({
								title: defaultTitle
							});
						}
					} else {
						// 检查是否为首页
						if (route === 'pages/index/index') {
							// 延迟300ms确保locale已经写入缓存
							setTimeout(() => {
								// 从缓存中读取locale
								const locale = uni.getStorageSync('locale') || 'zh-CN';

								// 根据当前语言环境显示相应标题
								const homeTitle = locale === 'en-US'
									? 'BeiJieXing-Focus on smart metal welding field'
									: '北杰星-专注于智能金属焊接领域';

								uni.setNavigationBarTitle({
									title: homeTitle
								});
							}, 300);
						} else {
							// 普通的国际化标题处理
							try {
								// 尝试获取国际化标题
								const translatedTitle = this.$t(titleKey);

								// 更新导航栏标题（在H5平台也会影响浏览器标题）
								uni.setNavigationBarTitle({
									title: translatedTitle
								});
							} catch (error) {
								console.error('更新页面标题失败:', error);
							}
						}
					}
				} else {
					console.log('未找到路由对应的标题映射:', route);
				}
			}).catch(error => {
				console.error('导入页面标题映射失败:', error);
			});
		},





		//监听语言切换
		startLanguageCheck() {
			this.globalData.languageCheckTimer = setInterval(() => {
				let locale = uni.getStorageSync('locale')
				if (this.locale !== locale) {
					this.SetLanguage(locale)
				}
			}, 1000)
		},


		getCrmebCopyRight() {
			getCrmebCopyRight().then((res) => {
				uni.setStorageSync('copyRight', res.data);
				uni.setStorageSync('forbidden', res.data.forbidden);
				uni.setStorageSync('shop_imgs', res.data.shop_imgs); //中英文轮播图数组
				uni.setStorageSync('purview', res.data.purview); // 权限设置
				uni.setStorageSync('comment', res.data.comment); // 评论开关
				uni.setStorageSync('dynamic', res.data.dynamic); // 动态开关
				uni.setStorageSync('show_ico', res.data.show_ico); // 首页分类图标开关
				uni.setStorageSync('index_ico', res.data.index_ico); // 首页图标
				uni.setStorageSync('logo_en', res.data.logo_en); // 英文logo
				uni.setStorageSync('TradePattern', res.data.TradePattern); // 贸易模式
				uni.setStorageSync('bank', res.data.bank); // 银行列表
			});
		},

		// #ifdef H5
		saveLoginInfo(data) {
			let token = data.token;
			let expires_time = data.expires_time;
			const authLocalToken = encodeURIComponent('Bearer ' + token);
			this.setCookie('auth.strategy', 'local1', 15);
			this.setCookie('auth._token.local1', authLocalToken, 15);
			this.setCookie('token', token, 15);
			this.setCookie('expires_time', expires_time, 15);
			this.setCookie('auth._refresh_token.local1', 'false', 15);
		},
		setCookie(name, value, days) {
			let expires = "";
			if (days) {
				const date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "") + expires + "; path=/";
		},
		// #endif

		remoteRegister(remote_token) {
			remoteRegister({
				remote_token
			}).then((res) => {
				let data = res.data;
				if (data.get_remote_login_url) {
					location.href = data.get_remote_login_url
				} else {
					this.$store.commit('LOGIN', {
						token: data.token,
						time: data.expires_time - this.$Cache.time()
					});
					this.$store.commit('SETUID', data.userInfo.uid);
					location.reload();
				}
			});
		},

	}
};
</script>

<style>
@import url('@/plugin/emoji-awesome/css/tuoluojiang.css');
@import url('@/plugin/animate/animate.min.css');
@import 'static/css/base.css';
@import 'static/iconfont/iconfont.css';
@import 'static/css/guildford.css';
@import 'static/css/style.scss';
@import 'static/css/app.css';

view {
	box-sizing: border-box;
}

page {
	font-family: PingFang SC;
}

.bg-color-red {
	background-color: var(--view-theme) !important;
}

.syspadding {
	padding-top: var(--status-bar-height);
}

.flex {
	display: flex;
}

.uni-scroll-view::-webkit-scrollbar {
	/* 隐藏滚动条，但依旧具备可以滚动的功能 */
	display: none;
}

::-webkit-scrollbar {
	width: 0;
	height: 0;
	color: transparent;
}

.uni-system-open-location .map-content.fix-position {
	height: 100vh;
	top: 0;
	bottom: 0;
}

.open-location {
	width: 100%;
	height: 100vh;
}

.goBack {
	font-size: 24rpx;
	width: 96rpx;
	height: 96rpx;
	background-color: rgba(255, 147, 75, 0.9);
	box-shadow: 0 0 15rpx rgba(255, 184, 2, 0.5);
	color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	border-radius: 50%;
	position: fixed;
	bottom: 180rpx;
	right: 20rpx;
	animation: breathingLight 2s infinite ease-in-out;
}

@keyframes breathingLight {

	50% {
		box-shadow: 0 0 30rpx rgba(255, 94, 20, 0.8);
	}
}

/* 弹窗层级 */
uni-toast {
	z-index: 9999999 !important;
}
</style>